import { combineReducers } from "redux";

import { reducer as formReducer } from "../utils/components/form";
import metalsStorage from "./metals-reducer";
import currenciesStorage from "./currencies-reducer";
import panelStorage from "./panel-reducer";
import basketStorage from "./basket-reducer";
import configStorage from "./config-reducer";
import messageStorage from "./message-reducer";
import pageStorage from "./page-reducer";
import denominatorStorage from "./denominator-reducer";
import mandantStorage from "./mandant-reducer";
import kundenStorage from "./kunden-reducer";
import rightStorage from "./right-reducer";
import kundenAdresseStorage from "./kundenAdresse-reducer";
import konditionenStorage from "./konditionen-reducer";
import auftragStorage from "./auftrag-reducer";
import authenticationStorage from "./auth-reducer";
import kurslisteStorage from "./kursliste-reducer";
import lieferadressenStorage from "./lieferadressen-reducer";
import hinweiseStorage from "./hinweise-reducer";

export const reducers =
{
  metalsStorage,
  currenciesStorage,
  panelStorage,
  basketStorage,
  configStorage,
  messageStorage,
  pageStorage,
  denominatorStorage,
  form: formReducer,
  mandantStorage,
  kundenStorage,
  kundenAdresseStorage,
  konditionenStorage,
  auftragStorage,
  kurslisteStorage,
  lieferadressenStorage,
  rightStorage,
  authenticationStorage,
  hinweiseStorage
}
export default combineReducers(reducers);
